import { Component, Input, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { NotificationTime } from '@shared/restaurant/enums';
import { Notification, Party } from '@shared/party/models';
import { LabelsEnum } from '@shared/sms/enums';
import { AppIcon, AppIconColor } from '@tablesready/frontend-icons';
import { ClockService } from '@tablesready/frontend-alerts-bar';

export interface NotifyActions<T> {
  smsPage: (party: T) => void;
  disableMessageButton: (party: T) => boolean;
  mergeInboundOutbound: (party: T) => Notification[];
  voicePage?: (party: T) => void;
}

@Component({
  selector: 'tablesready-waitlist-notify',
  templateUrl: './waitlist-notify.component.html',
  styleUrls: ['./waitlist-notify.component.scss'],
})
export class WaitlistNotifyComponent<T extends Party> implements OnInit {
  @Input() hideButtons = false;
  @Input() voicePageNotificationEnabled = false;
  @Input() notificationTime = NotificationTime.Relative;
  @Input() party?: T;
  @Input() timezone?: string;
  @Input() togoMode = false;
  @Input() index = 0;
  @Input() notifyActions?: NotifyActions<Party>;
  @Input() isMobile = false;

  now: number;
  notificationTimeEnum = NotificationTime;
  callBtnFocus: Record<number, boolean> = { };
  icon = AppIcon;
  color = AppIconColor;
  notificationLabelsEnum = LabelsEnum;

  private readonly subscription = new Subscription();

  constructor(private readonly clockService: ClockService) {}

  ngOnInit(): void {
    const timeSub = this.clockService.clock$
      .subscribe((now) => {
        this.now = now;
      });

    this.subscription.add(timeSub);
  }
}
